import React, { useEffect, useState } from 'react';
import { Card, MetricCard, Plate } from '../components/Card';
import { getOnecDebts } from '../api';

const fmt = n => n ? n.toLocaleString('ru-RU', { maximumFractionDigits: 0 }) + ' ₽' : '0 ₽';

export default function Debts() {
  const [debts, setDebts] = useState([]);
  const [tab, setTab] = useState('all');

  useEffect(() => {
    getOnecDebts(tab === 'all' ? undefined : tab).then(setDebts).catch(() => {});
  }, [tab]);

  const debtors = debts.filter(d => d.type === 'debtor');
  const creditors = debts.filter(d => d.type === 'creditor');
  const debtorTotal = debtors.reduce((s, d) => s + d.amount, 0);
  const creditorTotal = creditors.reduce((s, d) => s + d.amount, 0);

  const visible = tab === 'all' ? debts : tab === 'debtor' ? debtors : creditors;

  return (
    <div>
      <div className="kp-hero">
        <Plate>Финансы · долги</Plate>
        <h1>Дебиторка и кредиторка</h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 24 }}>
        <MetricCard title="Дебиторка (нам должны)" value={fmt(debtorTotal)} color="var(--green)" />
        <MetricCard title="Кредиторка (мы должны)" value={fmt(creditorTotal)} color="var(--red)" />
        <MetricCard title="Баланс" value={fmt(debtorTotal - creditorTotal)}
          color={debtorTotal >= creditorTotal ? 'var(--green)' : 'var(--red)'} />
      </div>

      <Card title="Задолженности" action={
        <div style={{ display: 'flex', gap: 4 }}>
          {[['all','Все'],['debtor','Дебиторы'],['creditor','Кредиторы']].map(([val, label]) => (
            <button key={val} onClick={() => setTab(val)} style={{
              padding: '6px 12px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 12,
              background: tab === val ? 'var(--accent)' : 'var(--bg3)',
              color: tab === val ? '#fff' : 'var(--text2)',
            }}>{label}</button>
          ))}
        </div>
      }>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)' }}>
                {['Контрагент', 'Тип', 'Сумма'].map(h => (
                  <th key={h} style={{ padding: '8px 12px', textAlign: 'left', color: 'var(--text2)', fontSize: 12 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {visible.map((d, i) => (
                <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '10px 12px' }}>{d.counterparty}</td>
                  <td style={{ padding: '10px 12px' }}>
                    <span style={{ color: d.type === 'debtor' ? 'var(--green)' : 'var(--red)', fontWeight: 600, fontSize: 12 }}>
                      {d.type === 'debtor' ? '↑ Дебитор' : '↓ Кредитор'}
                    </span>
                  </td>
                  <td style={{ padding: '10px 12px', fontWeight: 600,
                    color: d.type === 'debtor' ? 'var(--green)' : 'var(--red)' }}>
                    {fmt(d.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!visible.length && <div style={{ padding: 20, color: 'var(--text2)', textAlign: 'center' }}>Нет данных</div>}
        </div>
      </Card>
    </div>
  );
}
